/**************************************************************************************************/
/*   File: /src/app/stores/selectors/dossiers/selectors.ts                                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Apr 17 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducers from '../../reducers/dossiers/reducer';
import * as fromStates from '../../states/dossiers';

/**
 * Get the dossiers State
 */
export const getDossiersState = createFeatureSelector<fromStates.DossiersState>('dossiers');
/**
 * Get is loading
 */
export const getIsLoading = createSelector(
    getDossiersState,
    fromReducers.helpers.getIsLoading
);
/**
 * Get messages
 */
export const getMessages = createSelector(
    getDossiersState,
    fromReducers.helpers.getMessages
);
/**
 * Get dossiers
 */
export const getDossiers = createSelector(
    getDossiersState,
    fromReducers.helpers.getDossiers
);